function Header() {
    return (
        <div className="header">
            <h1>Who are you here to see?</h1>
        </div>
    );
}

export default Header;